module.exports = __webpack_public_path__ + "img/Search.e21a4b0a.png";